<template>
  <div class="san-background-blush" />
</template>

<script setup>
defineOptions({ name: 'SanBackgroundBlush' })
</script>
